module.exports = __webpack_public_path__ + "img/cikarang.b21caef7.svg";